export default __webpack_public_path__ + "static/media/business-background-4.0871429e.webp";